import * as Types from '@x/schemas/ecommerce';

import { gql } from 'apollo-angular';
import { ShopGeoRegionDetailFragmentDoc } from './shop-region.gql.generated';
import { ShopMetaFragmentDoc } from './shop-meta.gql.generated';
import { ShopCollectionPointFragmentDoc } from './shop-collection.gql.generated';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type ShopChannelItemAttributesFragment = { __typename: 'ShopChannelObject', id: number, code: string, name: string, contentRef?: string | null | undefined, currency: string, defaultLocale: string, defaultCountry?: string | null | undefined, locales: Array<string>, rootTaxonId?: number | null | undefined, regions: Array<{ __typename: 'ShopGeoRegionObject', id: number, name: string, parentId?: number | null | undefined, channelId: number }> };

export type ShopChannelDetailAttributesFragment = { __typename: 'ShopChannelObject', id: number, code: string, name: string, contentRef?: string | null | undefined, currency: string, defaultLocale: string, defaultCountry?: string | null | undefined, locales: Array<string>, rootTaxonId?: number | null | undefined, regions: Array<{ __typename: 'ShopGeoRegionObject', id: number, name: string, code: string, channelCode: string, channelId: number, parentId?: number | null | undefined, label?: string | null | undefined, description?: string | null | undefined, definitions: Array<{ __typename: 'ShopGeoRegionDefinition', id: number, center?: any | null | undefined, boundary?: any | null | undefined }> }>, meta?: { __typename: 'ShopMetaContentObject', description?: string | null | undefined, title?: string | null | undefined, keywords?: string | null | undefined } | null | undefined, defaultCollectionPoint?: { __typename: 'ShopCollectionPointObject', id: number, name: string, address: { __typename: 'ShopAddressObject', id: number, type: Types.AddressType, alias?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, email?: string | null | undefined, phoneNumber?: string | null | undefined, street?: string | null | undefined, complex?: string | null | undefined, suburb?: string | null | undefined, city?: string | null | undefined, businessName?: string | null | undefined, postalCode?: string | null | undefined, province?: string | null | undefined, country: string, instructions?: string | null | undefined, hash: string, coordinates?: any | null | undefined, isDefaultShippingAddress?: boolean | null | undefined, isDefaultBillingAddress?: boolean | null | undefined, recipientHash?: string | null | undefined, region?: { __typename: 'ShopGeoRegionObject', id: number, name: string, code: string, channelCode: string, channelId: number, parentId?: number | null | undefined, label?: string | null | undefined, description?: string | null | undefined, definitions: Array<{ __typename: 'ShopGeoRegionDefinition', id: number, center?: any | null | undefined, boundary?: any | null | undefined }> } | null | undefined } } | null | undefined };

export type ShopChannelCheckoutDetailFragment = { __typename: 'ShopChannelObject', id: number, code: string, name: string, enquiryOnly: boolean, currency: string, defaultLocale: string, defaultCountry?: string | null | undefined, regions: Array<{ __typename: 'ShopGeoRegionObject', id: number, name: string, code: string, channelCode: string, channelId: number, parentId?: number | null | undefined, label?: string | null | undefined, description?: string | null | undefined, definitions: Array<{ __typename: 'ShopGeoRegionDefinition', id: number, center?: any | null | undefined, boundary?: any | null | undefined }> }> };

export type ShopChannelSuggestionFragment = { __typename: 'ShopChannelSuggestionObject', defaultChannel?: { __typename: 'ShopChannelObject', code: string } | null | undefined, preferredChannel?: { __typename: 'ShopChannelObject', code: string } | null | undefined, usableChannel?: { __typename: 'ShopChannelObject', code: string } | null | undefined };

export type ShopAdMediaFragment = { __typename: 'ShopAdMediaObject', mediaQuery: string, placement?: string | null | undefined, type: string, url: string, width?: number | null | undefined, height?: number | null | undefined, alt?: string | null | undefined, originalName?: string | null | undefined };

export type ShopChannelDetailByCodeQueryVariables = Types.Exact<{
  code: Types.Scalars['String']['input'];
  locale: Types.Scalars['String']['input'];
}>;


export type ShopChannelDetailByCodeQuery = { __typename: 'Query', shopChannel: { __typename: 'ShopChannelObject', id: number, code: string, name: string, contentRef?: string | null | undefined, currency: string, defaultLocale: string, defaultCountry?: string | null | undefined, locales: Array<string>, rootTaxonId?: number | null | undefined, regions: Array<{ __typename: 'ShopGeoRegionObject', id: number, name: string, code: string, channelCode: string, channelId: number, parentId?: number | null | undefined, label?: string | null | undefined, description?: string | null | undefined, definitions: Array<{ __typename: 'ShopGeoRegionDefinition', id: number, center?: any | null | undefined, boundary?: any | null | undefined }> }>, meta?: { __typename: 'ShopMetaContentObject', description?: string | null | undefined, title?: string | null | undefined, keywords?: string | null | undefined } | null | undefined, defaultCollectionPoint?: { __typename: 'ShopCollectionPointObject', id: number, name: string, address: { __typename: 'ShopAddressObject', id: number, type: Types.AddressType, alias?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, email?: string | null | undefined, phoneNumber?: string | null | undefined, street?: string | null | undefined, complex?: string | null | undefined, suburb?: string | null | undefined, city?: string | null | undefined, businessName?: string | null | undefined, postalCode?: string | null | undefined, province?: string | null | undefined, country: string, instructions?: string | null | undefined, hash: string, coordinates?: any | null | undefined, isDefaultShippingAddress?: boolean | null | undefined, isDefaultBillingAddress?: boolean | null | undefined, recipientHash?: string | null | undefined, region?: { __typename: 'ShopGeoRegionObject', id: number, name: string, code: string, channelCode: string, channelId: number, parentId?: number | null | undefined, label?: string | null | undefined, description?: string | null | undefined, definitions: Array<{ __typename: 'ShopGeoRegionDefinition', id: number, center?: any | null | undefined, boundary?: any | null | undefined }> } | null | undefined } } | null | undefined } };

export type ShopChannelsQueryVariables = Types.Exact<{
  locale: Types.Scalars['String']['input'];
}>;


export type ShopChannelsQuery = { __typename: 'Query', shopChannels: Array<{ __typename: 'ShopChannelObject', id: number, code: string, name: string, contentRef?: string | null | undefined, currency: string, defaultLocale: string, defaultCountry?: string | null | undefined, locales: Array<string>, rootTaxonId?: number | null | undefined, regions: Array<{ __typename: 'ShopGeoRegionObject', id: number, name: string, parentId?: number | null | undefined, channelId: number }> }> };

export type ShopChannelCheckoutDetailByCodeQueryVariables = Types.Exact<{
  code: Types.Scalars['String']['input'];
  locale: Types.Scalars['String']['input'];
}>;


export type ShopChannelCheckoutDetailByCodeQuery = { __typename: 'Query', shopChannel: { __typename: 'ShopChannelObject', id: number, code: string, name: string, enquiryOnly: boolean, currency: string, defaultLocale: string, defaultCountry?: string | null | undefined, regions: Array<{ __typename: 'ShopGeoRegionObject', id: number, name: string, code: string, channelCode: string, channelId: number, parentId?: number | null | undefined, label?: string | null | undefined, description?: string | null | undefined, definitions: Array<{ __typename: 'ShopGeoRegionDefinition', id: number, center?: any | null | undefined, boundary?: any | null | undefined }> }> } };

export type ShopSuggestChannelsQueryVariables = Types.Exact<{
  locale: Types.Scalars['String']['input'];
  ipAddress?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type ShopSuggestChannelsQuery = { __typename: 'Query', shopSuggestChannels: { __typename: 'ShopChannelSuggestionObject', defaultChannel?: { __typename: 'ShopChannelObject', code: string } | null | undefined, preferredChannel?: { __typename: 'ShopChannelObject', code: string } | null | undefined, usableChannel?: { __typename: 'ShopChannelObject', code: string } | null | undefined } };

export type ShopChannelMetaByCodeQueryVariables = Types.Exact<{
  code: Types.Scalars['String']['input'];
  locale: Types.Scalars['String']['input'];
}>;


export type ShopChannelMetaByCodeQuery = { __typename: 'Query', shopChannel: { __typename: 'ShopChannelObject', name: string, meta?: { __typename: 'ShopMetaContentObject', description?: string | null | undefined, title?: string | null | undefined, keywords?: string | null | undefined } | null | undefined } };

export const ShopChannelItemAttributesFragmentDoc = gql`
    fragment ShopChannelItemAttributes on ShopChannelObject {
  id
  code
  name
  regions {
    id
    name
    parentId
    channelId
  }
  contentRef
  currency
  defaultLocale
  defaultCountry
  locales
  rootTaxonId
}
    `;
export const ShopChannelDetailAttributesFragmentDoc = gql`
    fragment ShopChannelDetailAttributes on ShopChannelObject {
  id
  code
  name
  regions {
    ...ShopGeoRegionDetail
  }
  contentRef
  currency
  defaultLocale
  defaultCountry
  locales
  rootTaxonId
  meta {
    ...ShopMeta
  }
  defaultCollectionPoint {
    ...ShopCollectionPoint
  }
}
    ${ShopGeoRegionDetailFragmentDoc}
${ShopMetaFragmentDoc}
${ShopCollectionPointFragmentDoc}`;
export const ShopChannelCheckoutDetailFragmentDoc = gql`
    fragment ShopChannelCheckoutDetail on ShopChannelObject {
  id
  code
  name
  enquiryOnly
  currency
  defaultLocale
  defaultCountry
  regions {
    ...ShopGeoRegionDetail
  }
}
    ${ShopGeoRegionDetailFragmentDoc}`;
export const ShopChannelSuggestionFragmentDoc = gql`
    fragment ShopChannelSuggestion on ShopChannelSuggestionObject {
  defaultChannel {
    code
  }
  preferredChannel {
    code
  }
  usableChannel {
    code
  }
}
    `;
export const ShopAdMediaFragmentDoc = gql`
    fragment ShopAdMedia on ShopAdMediaObject {
  mediaQuery
  placement
  type
  url
  width
  height
  alt
  originalName
}
    `;
export const ShopChannelDetailByCodeDocument = gql`
    query ShopChannelDetailByCode($code: String!, $locale: String!) {
  shopChannel(locale: $locale, code: $code) {
    ...ShopChannelDetailAttributes
  }
}
    ${ShopChannelDetailAttributesFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopChannelDetailByCodeGQL extends Apollo.Query<ShopChannelDetailByCodeQuery, ShopChannelDetailByCodeQueryVariables> {
    document = ShopChannelDetailByCodeDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShopChannelsDocument = gql`
    query ShopChannels($locale: String!) {
  shopChannels(locale: $locale) {
    ...ShopChannelItemAttributes
  }
}
    ${ShopChannelItemAttributesFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopChannelsGQL extends Apollo.Query<ShopChannelsQuery, ShopChannelsQueryVariables> {
    document = ShopChannelsDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShopChannelCheckoutDetailByCodeDocument = gql`
    query ShopChannelCheckoutDetailByCode($code: String!, $locale: String!) {
  shopChannel(locale: $locale, code: $code) {
    ...ShopChannelCheckoutDetail
  }
}
    ${ShopChannelCheckoutDetailFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopChannelCheckoutDetailByCodeGQL extends Apollo.Query<ShopChannelCheckoutDetailByCodeQuery, ShopChannelCheckoutDetailByCodeQueryVariables> {
    document = ShopChannelCheckoutDetailByCodeDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShopSuggestChannelsDocument = gql`
    query ShopSuggestChannels($locale: String!, $ipAddress: String) {
  shopSuggestChannels(locale: $locale, ipAddress: $ipAddress) {
    ...ShopChannelSuggestion
  }
}
    ${ShopChannelSuggestionFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopSuggestChannelsGQL extends Apollo.Query<ShopSuggestChannelsQuery, ShopSuggestChannelsQueryVariables> {
    document = ShopSuggestChannelsDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShopChannelMetaByCodeDocument = gql`
    query ShopChannelMetaByCode($code: String!, $locale: String!) {
  shopChannel(locale: $locale, code: $code) {
    meta {
      description
      title
      keywords
    }
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopChannelMetaByCodeGQL extends Apollo.Query<ShopChannelMetaByCodeQuery, ShopChannelMetaByCodeQueryVariables> {
    document = ShopChannelMetaByCodeDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }